import { Store } from 'vuex'
import State from '../store/types'

export function getDirectives(store: Store<State>) {
  return {
    hideIf: {
      inserted: function(el, binding) {
        const securityState = (store.state as any).security
        const permission = securityState.currentUser.EffectivePermissions.find((p) => {
          return p.ModuleId === binding.value.module
        })

        const modifier = Object.keys(binding.modifiers)[0]

        if (permission === undefined || modifier === undefined) {
          el.hidden = true
          return
        }

        if (modifier === 'cantRead') {
          el.hidden = !permission.CantRead
        } else if (modifier === 'cantWrite') {
          el.hidden = !permission.CanWrite
        } else if (modifier === 'cantExecute') {
          el.hidden = !permission.CanExecute
        } else if (modifier === 'cantDelete') {
          el.hidden = !permission.CanDelete
        } else {
          el.hidden = true
        }
      },
    },
  }
}
